"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var interfaces_1 = require("@hudled/interfaces");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var reactstrap_1 = require("reactstrap");
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var single_1 = require("utils/selectors/single");
var getAggregates_1 = require("./getAggregates");
var StatGroup_1 = __importDefault(require("./StatGroup"));
var PREFIX = 'OptimiseOverviewStats';
var classes = {
    highlightText: "".concat(PREFIX, "-highlightText"),
    center: "".concat(PREFIX, "-center"),
    bar: "".concat(PREFIX, "-bar"),
    action: "".concat(PREFIX, "-action"),
    fullWidth: "".concat(PREFIX, "-fullWidth"),
};
// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root = (0, styles_1.styled)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.highlightText)] = {
            // ...theme.typography.body2,
            fontSize: theme.typography.body2.fontSize,
            lineHeight: theme.typography.body2.lineHeight,
        },
        _b[".".concat(classes.center)] = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        _b[".".concat(classes.bar)] = {
            marginTop: '4px',
            flexBasis: '50%',
        },
        _b[".".concat(classes.action)] = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            maxWidth: '50%',
            marginLeft: 'auto',
            marginTop: '-4px',
        },
        _b[".".concat(classes.fullWidth)] = {
            width: '100%',
        },
        _b);
});
var OptimiseOverviewStats = function (_a) {
    var _b;
    var recommendations = _a.recommendations, selectedRecommendations = _a.selectedRecommendations;
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    // const currentRecArr = [RECOMMENDATIONS_TYPE.FX, RECOMMENDATIONS_TYPE.NEGOT];
    // const auth = useSelector(selectAuth);
    // const orderedRecommendations = useSelector(selectPopulatedRecommendationsArray)
    // ?.filter((rec) => currentRecArr.includes(rec.type));
    // const ownersToFilterBy = [auth.uid];
    // const statusSummary = orderedRecommendations && summarizeRecommendationsPerStatus(orderedRecommendations);
    // const STATUS_MAP = { toAction: 'to action', inProgress: 'in progress', actioned: 'actioned' };
    // const partialSummary = statusSummary && getFormattedStatusSummary(statusSummary, ownersToFilterBy, STATUS_MAP);
    // const totalActions = partialSummary?.actionedCount + partialSummary?.toActionCount + partialSummary?.inProgressCount;
    // const completionPercentage = Math.round((partialSummary?.actionedCount / totalActions) * 100);
    var recommendationAggregates = (company || {}).recommendationAggregates;
    var canAdmin = (0, end2end_1.userCan)(interfaces_1.ACCESS_LEVEL.Admin)(profile);
    var agg = (0, getAggregates_1.useAggStats)(recommendationAggregates, profile, canAdmin, recommendations);
    var location = (0, react_router_1.useLocation)();
    if (!company || !agg)
        return null;
    var queryParams = new URLSearchParams(location.search);
    var recTypes = ((_b = queryParams.get('rec_types')) === null || _b === void 0 ? void 0 : _b.split(',').filter(Boolean)) || [];
    var getNewRecTypes = function (type) { return recTypes.includes(type) ? recTypes.filter(function (r) { return r !== type; }) : recTypes.concat(type); };
    var getStatForJustince = function (type) { return ({
        type: type,
        actionCount: agg.countByRecType[interfaces_1.RECOMMENDATIONS_TYPE[type]] || 0,
        amount: agg.sumByRecType[interfaces_1.RECOMMENDATIONS_TYPE[type]] || 0,
        link: getNewRecTypes(type).length === 0 ? '/recommendations'
            : "/recommendations?rec_types=".concat(getNewRecTypes(type).join(',')),
    }); };
    var msaStatDescriptionTempls = [
        __assign({ 
            // ToDo: refactor this
            // eslint-disable-next-line react/no-unstable-nested-components
            descriptionTmpl: function (keyword) { return ((0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 2 }, { children: ["in ", (0, jsx_runtime_1.jsx)("strong", __assign({ className: classes.highlightText }, { children: "Forex Costs" })), " ", (0, jsx_runtime_1.jsx)("br", {}), "with ", (0, jsx_runtime_1.jsx)("strong", __assign({ className: classes.highlightText }, { children: keyword })), " actions"] }))); } }, getStatForJustince('FX')),
        __assign({ 
            // ToDo: refactor this
            // eslint-disable-next-line react/no-unstable-nested-components
            descriptionTmpl: function (keyword) { return ((0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 2 }, { children: ["in ", (0, jsx_runtime_1.jsx)("strong", __assign({ className: classes.highlightText }, { children: "Negotiations" })), " ", (0, jsx_runtime_1.jsx)("br", {}), "with ", (0, jsx_runtime_1.jsx)("strong", __assign({ className: classes.highlightText }, { children: (0, end2end_1.handlePlural)('action')(keyword) }))] }))); } }, getStatForJustince('NEGOT')),
        // {
        //   descriptionTmpl: (keyword) => (
        //     <Text level={2}>in <strong className={classes.highlightText}>Dormant Users</strong> <br />
        //       with <strong className={classes.highlightText}>{keyword}</strong> actions</Text>
        //   ),
        //   ...getStatForJustince('DORM'),
        // },
    ].filter(function (rec) { return ['FX', 'NEGOT'].includes(rec.type); });
    return (((0, jsx_runtime_1.jsxs)(Root, { children: [(0, jsx_runtime_1.jsx)(reactstrap_1.Row, { children: (0, jsx_runtime_1.jsx)(reactstrap_1.Col, __assign({ className: classes.center }, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: "Opportunities to optimise" })) })) }), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ ml: -2 }, { children: (0, jsx_runtime_1.jsx)(StatGroup_1.default, { otherStats: msaStatDescriptionTempls, headerStat: { amount: agg.totalSum, count: agg.totalCount }, selected: selectedRecommendations }) }))] })));
};
exports.default = OptimiseOverviewStats;
